import { HelpfulTopics, addStaticCards } from './helpful-topics';

export default HelpfulTopics;

export { addStaticCards };
